    import React from 'react';
    export const AuthContext = React.createContext({
        isAuthenticated: false,
        isReportReader: false,
        isAdministrator: false,
        isNocProf: false,
        accessToken: ""
    });